(function($) {

    $('a[href^="#"]')
      .not('[href="#"]')
      .on('click', function(e) {         
        e.preventDefault();
        var hash    = this.hash;
        smoothScroll(hash,false);
    });

    if(window.location.hash) {
        $('html').stop().animate({scrollTop:0});
    }

    $(window).on('load',function(){
        if(window.location.hash) {
            smoothScroll(window.location.hash,false);
        }
    });    

    function smoothScroll(hash,contactRepeat) {  
        console.log('smooth scrolling...');
        var target  = $(hash);
        if (target.length) {  
            if (hash == "#begin") { // special case for beginning area
                // JS
            }
            var distance = Math.abs(target.offset().top - $(window).scrollTop());
            var offset  = $('.header__top').outerHeight() + 10; 
            var dataOffset = target.data('offset') === undefined ? 0 : target.data('offset');           
            $('html').stop().animate({
                scrollTop: target.offset().top - offset + dataOffset
            }, distance/2,function(){
                if (!contactRepeat) {
                    console.log('running post-scroll fxn...');                
                    target.addClass('scrolled-to');
                    // location.hash = hash;
                    if (hash == "#contact") { // special case for contact hash
                        console.log('special case for contact!');
                        $('.footer__contact__bar').text('How can I help?');
                        smoothScroll('#contact',true);
                    }
                }
            });
        } else {
            console.log('cannot find target: '+hash);
        }
    }

})( jQuery ); 